export const replaceBaseUrl = (url) => {
  const parts = url.split('/orders/');
  if (parts.length > 1) {
    return `/orders/${parts[1]}`;
  }

  return url;
};
